"use client";
import { useState, useEffect, useContext, useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  IconButton,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Autocomplete,
  TextField,
  alpha,
  Tooltip,
  InputAdornment,
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { ErpContext } from "../../context/ErpContext.js";
import "./TablaVentasComponent.css";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import DeleteIcon from "@mui/icons-material/Delete";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import SearchIcon from "@mui/icons-material/Search";
import ReplayIcon from "@mui/icons-material/Replay";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

import dayjs from "dayjs";

import "./TablaTransaccionComponent.css";

import ModalViewTablaVenta from "./ModalViewTablaVenta.js";
import ModalViewTablaCompra from "./ModalViewTablaCompra.js";
import ModalViewTablaPresupuesto from "./ModalViewTablaPresupuesto.js";
import ModalViewTablaIngreso from "./ModalViewTablaIngreso.js";
import ModalViewTablaEgreso from "./ModalViewTablaEgreso.js";
import ModalViewTablaDevolucion from "./ModalViewTablaDevolucion.js";

import Swal from "sweetalert2";

import CustomPagination from "./CustomPagination"; // Tu componente de paginación

const theme = createTheme({
  palette: {
    mode: "light",
  },
});

export default function TablaVentas() {
  const {
    getTipoTransaccion,
    tipoTransaccion,
    getEntidad,
    entidades,
    getMedioDePago,
    medioDePago,
    getTransaccionItem,
    getTransaccionItemID,
    generarFacturaPDF,
    itemUbicacion,
    getTransaccionTransformed,
    fetchFilteredTransactions,
    tipoMedioDePago,
    medioDePagoIdTipoEspecifico,
    getTipoMedioDePago,
    getMedioDePagoIdTipoEspecifico,
    getEntidadByID,
    getItemById,
    getItemUbicacionFilter,
    generarRemitoPDF,
    updateDeleteTransaccion,
    entidadesClientesTresLetras,
    getEntidadesClientesTresLetras,
    isNavbarCollapsed,
    getFechaHoraActualClient,
  } = useContext(ErpContext);

  const [formattedTransacciones, setFormattedTransacciones] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openModalVenta, setOpenModalVenta] = useState(false);
  const [openModalCompra, setOpenModalCompra] = useState(false);
  const [openModalPresupuesto, setOpenModalPresupuesto] = useState(false);
  const [openModalIngreso, setOpenModalIngreso] = useState(false);
  const [openModalEgreso, setOpenModalEgreso] = useState(false);
  const [openModalDevolucion, setOpenModalDevolucion] = useState(false);
  const [transaccionItems, setTransaccionItems] = useState([]);
  const [selectedTransaccionId, setSelectedTransaccionId] = useState(null);
  const [selectedTransaccion, setSelectedTransaccion] = useState(null);
  const [selectedTransaccionEntidad, setSelectedTransaccionEntidad] =
    useState(null);

  const [selectedTipoMedioDePago, setSelectedTipoMedioDePago] = useState(null);
  const [selectedMedioDePago, setSelectedMedioDePago] = useState(null);
  const [selectedTipoTransaccion, setSelectedTipoTransaccion] = useState(null);

  const [transaccionTransformedReforged, setTransaccionTransformedReforged] =
    useState([]);
  const [totalesPorTipoMedioDePago, setTotalesPorTipoMedioDePago] =
    useState(null);
  const [totalesPorTipo, setTotalesPorTipo] = useState(null);

  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100); // Cantidad de filas por página

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [idTransaccionSearch, setIdTransaccionSearch] = useState(null);
  const [dniCliente, setDniCliente] = useState("");
  const [searchTextCliente, setSearchTextCliente] = useState("");

  const [filtersActive, setFiltersActive] = useState(false);

  const isFirstRender = useRef(true);

  useEffect(() => {
    const today = dayjs();
    setStartDate(today.subtract(30, "day"));
    setEndDate(today);
    fetchDataInicio();
  }, []);

  const fetchDataInicio = async () => {
    try {
      if (isFirstRender.current) {
        isFirstRender.current = false;
        return; // Evita la ejecución en el primer render
      }
      await getTipoTransaccion();
      await getMedioDePago();
      await getTransaccionTransformed();
      // fetchFilteredTransactions(today, endDateFormateado, null, null);
      await getTipoMedioDePago();
      await getMedioDePagoIdTipoEspecifico();
    } catch (error) {}
  };

  useEffect(() => {
    const medioDePagoId = selectedMedioDePago ? selectedMedioDePago.id : null;
    const tipoMedioDePagoId = selectedTipoMedioDePago
      ? selectedTipoMedioDePago.id
      : null;
    const tipoTransaccionId = selectedTipoTransaccion
      ? selectedTipoTransaccion.id
      : null;
      const idEntidad = dniCliente
      ? dniCliente.id
      : null;
    fetchData(
      startDate,
      endDate,
      medioDePagoId,
      tipoMedioDePagoId,
      tipoTransaccionId,
      page,
      idTransaccionSearch,
      idEntidad
    ); // Llamar a la función cada vez que cambia la página o la fecha
  }, [startDate, endDate]); // Llamar cada vez que cambia la fecha o la página

  useEffect(() => {
    const medioDePagoId = selectedMedioDePago ? selectedMedioDePago.id : null;
    const tipoMedioDePagoId = selectedTipoMedioDePago
      ? selectedTipoMedioDePago.id
      : null;
    const tipoTransaccionId = selectedTipoTransaccion
      ? selectedTipoTransaccion.id
      : null;
     const idEntidad = dniCliente
      ? dniCliente.id
      : null;
    fetchData(
      startDate,
      endDate,
      medioDePagoId,
      tipoMedioDePagoId,
      tipoTransaccionId,
      page,
      idTransaccionSearch,
      idEntidad
    );
  }, [page]); // Llamar cada vez que cambia la fecha o la página

  const fetchData = async (
    startDate,
    endDate,
    idMedioPago,
    tipoMedioDePagoId,
    idTipoTransaccion,
    page,
    idTransaccionSearch,
    idEntidad,
    limit = 100
  ) => {
    if (!startDate || !endDate) return;

    // ✅ Normalizar fechas con timezone usando getFechaHoraActualClient (patrón correcto)
    const validStartDate = startDate ? startDate : dayjs();
    const validEndDate = endDate ? endDate : dayjs();
    
    let formattedStartDate = validStartDate.format("YYYY-MM-DD");
    let formattedEndDate = validEndDate.format("YYYY-MM-DD");

    // Normalizar fechas con timezone del cliente
    const result1 = await getFechaHoraActualClient(formattedStartDate);
    const dateWithTimezoneStart = dayjs(result1.fechaServidor).startOf("day").toDate();

    const result2 = await getFechaHoraActualClient(formattedEndDate);
    const dateWithTimezoneEnd = dayjs(result2.fechaServidor).endOf("day").toDate();

    // Validar que las fechas sean válidas antes de enviar
    if (isNaN(dateWithTimezoneStart.getTime()) || isNaN(dateWithTimezoneEnd.getTime())) {
      console.error("Fechas inválidas generadas:", { dateWithTimezoneStart, dateWithTimezoneEnd, result1, result2 });
      return;
    }

    const data = await fetchFilteredTransactions(
      dateWithTimezoneStart,
      dateWithTimezoneEnd,
      idMedioPago,
      tipoMedioDePagoId,
      idTipoTransaccion,
      page,
      idTransaccionSearch,
      idEntidad,
      limit
    );

    if (!data) {
      setTransaccionTransformedReforged([]);
      setTotalCount(0);
      setTotalPages(0);
      return;
    }

    // mapeo directo de la respuesta del back a las columnas
    const rows = data.data.map((tx) => {
      const fechaCreada = new Intl.DateTimeFormat("es-AR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }).format(new Date(tx.fechaHoraCreacion));

      console.log(tx)

      const pagos = (tx.pagos || []).map((p) => ({
        descripcion: p.medioDePago,
        monto: p.montoTotal,
        id: p.pagoId,
        idMedioPago: p.idMedio,
        idTipoMedio: p.idtipoMedio 
      }));

      const pagoSeleccionado = pagos.find(
        (pago) => pago.idMedioPago === idMedioPago
      );
      const montoRestante = pagoSeleccionado ? pagoSeleccionado.monto : 0;

      return {
        id: tx.id,
        updatedAtMod: fechaCreada,
        montoTotal: tx.montoTotal,
        idTipoTransaccion: tx.tipoTransaccion?.descripcion || "",
        idDelTipoTransaccion: tx.tipoTransaccion?.id || "",
        pagos,
        descripcionEntidad: tx.entidad?.descripcion || "",
        usuario: tx.usuario?.usuario || "",
        ubicacion: tx.ubicacion?.descripcion || "",
        descripcionImpuestos: tx.descripcionImpuestos,
        montoRestante: montoRestante,
        descripcion: tx.descripcion,

        // cualquier otro campo que uses en columnas…
      };
    });

    setTransaccionTransformedReforged(rows);
    setTotalCount(data.totalCount);
    setTotalPages(data.totalPages);
    const totalesPorTipoData = calcularTotalesPorTipo(rows);
    const totalesPorTipoMedioDePagoData = calcularTotalesPorTipoMedioDePago(
      data.data
    );
    setTotalesPorTipoMedioDePago(totalesPorTipoMedioDePagoData);
    setTotalesPorTipo(totalesPorTipoData);
  };

  useEffect(() => {
    if (searchTextCliente.length >= 3) {
      getEntidadesClientesTresLetras(searchTextCliente, 1);
    }
  }, [searchTextCliente]);

  // Estado para las filas seleccionadas
  const [selectedRows, setSelectedRows] = useState([]);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 70,
      flex: 0.5,
      headerAlign: "center",
    },
    {
      field: "updatedAtMod",
      headerName: "Fecha",
      width: 200,
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "montoTotal",
      headerName: "Monto",
      type: "number",
      width: 130,
      flex: 1,
      headerAlign: "center",
      renderCell: (params) => {
        let color = "#4CAF50";

        if (
          params.row.idDelTipoTransaccion == 5 ||
          params.row.idDelTipoTransaccion == 2
        ) {
          color = "#FF9800";
        }
        if (
          params.row.idDelTipoTransaccion == 3 ||
          params.row.idDelTipoTransaccion == 6
        ) {
          color = "gray";
        }
        return (
          <span style={{ color, fontWeight: "bold" }}>
            ${params.value?.toLocaleString("es-AR") || "0.00"}
          </span>
        );
      },
    },
    ...(selectedMedioDePago
      ? [
          {
            field: "montoRestante",
            headerName: "Monto Pago Seleccionado",
            type: "number",
            width: 150,
            flex: 1,
            headerAlign: "center",
            renderCell: (params) => {
              let color = "#4CAF50";

              if (
                params.row.idDelTipoTransaccion == 5 ||
                params.row.idDelTipoTransaccion == 2
              ) {
                color = "#FF9800";
              }
              if (
                params.row.idDelTipoTransaccion == 3 ||
                params.row.idDelTipoTransaccion == 6
              ) {
                color = "gray";
              }
              return (
                <span style={{ color, fontWeight: "bold" }}>
                  ${params.value?.toLocaleString("es-AR") || "0.00"}
                </span>
              );
            },
          },
        ]
      : []), // Devuelve un array vacío en lugar de [{}]
    //{ field: "idMoneda", headerName: "Moneda", width: 90 },
    { field: "idTipoTransaccion", headerName: "Tipo Transacción", width: 150 },
    {
      field: "pagos",
      headerName: "Medio de Pago",
      width: 150,
      flex: 1,
      headerAlign: "center",
      renderCell: (params) => {
        const pagos = Array.isArray(params.row.pagos) ? params.row.pagos : [];
    
        if (pagos.length > 1) {
          // Mostrar múltiples medios de pago
          return (
            <div>
              <span style={{ fontWeight: "bold", color: "blue" }}>
                Múltiple
              </span>
            </div>
          );
        } else {
          // Mostrar un solo medio de pago
          return (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ fontWeight: "bold", color: "#00AAE4" }}>
                {pagos[0]?.descripcion || "N/A"}
              </span>
            </div>
          );
        }
      },
    },
    {
      field: "descripcionEntidad",
      headerName: "Entidad",
      width: 150,
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "usuario",
      headerName: "Usuario",
      width: 150,
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "ubicacion",
      headerName: "Ubicación",
      width: 150,
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "action",
      headerName: "Acciones",
      width: 180,
      flex: 1,
      headerAlign: "center",
      renderCell: (params) => (
        <>
          <IconButton
            className="colorGeneralParaIconos"
            onClick={() => handleOpenModal(params.row)}
          >
            <VisibilityIcon />
          </IconButton>
          <IconButton
            className="colorGeneralParaIconos"
            onClick={() => handleDownloadPDF(params.row)}
          >
            <PictureAsPdfIcon />
          </IconButton>
          {params.row.idTipoTransaccion === "Venta" ? (
            <IconButton
              className="colorGeneralParaIconos"
              onClick={() => handleDownloadRemito(params.row)}
            >
              <ReceiptLongIcon />
            </IconButton>
          ) : null}
          <Tooltip title="Borrar Transaccion">
            <IconButton
              className="colorGeneralParaIconos"
              onClick={() => borrarTransaccion(params.row)}
              size="small"
              sx={{
                bgcolor: "rgb(244, 177, 14, 0.2)",
                "&:hover": "rgb(244, 177, 14, 0.2)",
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  const calcularTotalesPorTipo = (data) => {
    const totales = {
      Venta: 0,
      Presupuesto: 0,
      Compra: 0,
      Ingreso: 0,
      Egreso: 0,
    };

    data.forEach((transaccion) => {
      const tipo = transaccion.idTipoTransaccion;
      if (totales[tipo] !== undefined) {
        console.log(totales[tipo]);

        totales[tipo] += transaccion.montoRestante;
      }
    });

    return totales;
  };

const calcularTotalesPorTipoMedioDePago = (data) => {
  const totales = {
    Venta: 0,
    Presupuesto: 0,
    Compra: 0,
    Ingreso: 0,
    Egreso: 0,
  };

  data.forEach((transaccion) => {
    const tipo = transaccion.tipoTransaccion.descripcion;
    if (totales[tipo] !== undefined) {
      // Aplico Math.abs() al monto antes de sumar
      totales[tipo] += Math.abs(transaccion.montoTotal);
    }
  });

  return totales;
};

  // Calcula los totales por tipo de transacción

  const handleDownloadPDF = async (transaccionRow) => {
    const transaccionEncontrada = await getTransaccionItemID(transaccionRow.id); // Obtener los items de la transacción
    const entidadCliente = await getEntidadByID(transaccionRow.idEntidadNumero);

    // Estructurar itemsTransaccion con datos completos

    /* HARDCODED WARNING ESTO PUEDE AFECTAR CUANDO HAYA MAS DE UNA UBICION PARA LOS ITEMS! */
    const itemsTransaccion = await Promise.all(
      transaccionEncontrada.map(async (transItem) => {
        const foundItem = await getItemById(transItem.idItem);

        // O si necesitas concatenarlo:
        const precio = transItem.precio;
        return {
          idItem: transItem.idItem,
          codigo: foundItem ? foundItem.codigo : "N/A",
          descripcion: foundItem
            ? foundItem.descripcion
            : "Descripción no disponible",
          cantidad: transItem.cantidad || 0,
          precio: transItem ? transItem.precio : 0,
          porcentajeDescuento: transItem ? transItem.porcentajeDescuento : 0,
          total: transItem
            ? (transItem.precio * transItem.cantidad).toFixed(2)
            : "0.00",
        };
      })
    );
    // Llamar a la función en el contexto para generar el PDF con "tablaVenta"
    generarFacturaPDF(
      transaccionRow,
      itemsTransaccion,
      entidadCliente,
      "tablaVenta",
      transaccionRow.impuestos
    );
  };

  const borrarTransaccion = async (transaccionRow) => {
    const result = await Swal.fire({
      title: "¿Estás seguro?",
      text: `Vas a eliminar la transacción con ID ${transaccionRow.id}. Esta acción no se puede deshacer.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    });

    if (result.isConfirmed) {
      try {
        // ejecuta la eliminación
        await updateDeleteTransaccion(transaccionRow.id);

        const medioDePagoId = selectedMedioDePago
          ? selectedMedioDePago.id
          : null;
        const tipoTransaccionId = selectedTipoTransaccion
          ? selectedTipoTransaccion.id
          : null;
        const tipoMedioDePagoId = selectedTipoMedioDePago
          ? selectedTipoMedioDePago.id
          : null;
        // refresca los datos (ajusta los args a tu fetchData)
        const idEntidad = dniCliente
      ? dniCliente.id
      : null;
    fetchData(
      startDate,
      endDate,
      medioDePagoId,
      tipoMedioDePagoId,
      tipoTransaccionId,
      page,
      idTransaccionSearch,
      idEntidad
    );

        Swal.fire({
          title: "Eliminado",
          text: `La transacción ${transaccionRow.id} ha sido eliminada.`,
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error("Error al borrar transacción:", error);
        Swal.fire({
          title: "Error",
          text: "No se pudo eliminar la transacción. Intenta de nuevo.",
          icon: "error",
        });
      }
    }
  };

  const handleDownloadRemito = async (transaccionRow) => {
    const transaccionEncontrada = await getTransaccionItemID(transaccionRow.id); // Obtener los items de la transacción
    const entidadCliente = await getEntidadByID(transaccionRow.idEntidadNumero);

    // Estructurar itemsTransaccion con datos completos

    /* HARDCODED WARNING ESTO PUEDE AFECTAR CUANDO HAYA MAS DE UNA UBICION PARA LOS ITEMS! */
    const itemsTransaccion = await Promise.all(
      transaccionEncontrada.map(async (transItem) => {
        const foundItem = await getItemById(transItem.idItem);
        const foundItemUbicacion = foundItem
          ? await getItemUbicacionFilter(foundItem.id)
          : null;

        // O si necesitas concatenarlo:
        const precio = foundItemUbicacion[0].precio;
        return {
          codigo: foundItem ? foundItem.codigo : "N/A",
          descripcion: foundItem
            ? foundItem.descripcion
            : "Descripción no disponible",
          cantidad: transItem.cantidad || 0,
          precio: foundItemUbicacion[0] ? foundItemUbicacion[0].precio : 0,
          porcentajeDescuento: foundItemUbicacion[0]
            ? transItem.porcentajeDescuento
            : 0,
          total: foundItemUbicacion[0]
            ? (foundItemUbicacion[0].precio * transItem.cantidad).toFixed(2)
            : "0.00",
        };
      })
    );
    // Llamar a la función en el contexto para generar el PDF con "tablaVenta"
    generarRemitoPDF(
      transaccionRow,
      itemsTransaccion,
      entidadCliente,
      transaccionRow.usuario,
      "tablaVenta",
      transaccionRow.impuestos
    );
  };

  const [calculatedTotal, setCalculatedTotal] = useState(null); // Para almacenar el monto calculado
  const [totalMontoDescuento, setTotalMontoDescuento] = useState(null); // Para almacenar el monto calculado
  const [totalPorcentajeDescuento, setPorcentajeDescuento] = useState(null); // Para almacenar el monto calculado
  const [montoSinImpuesto, setMontoSinImpuesto] = useState(null); // Para almacenar el monto calculado

  const handleOpenModal = async (transaccionRow) => {
    setSelectedTransaccion(transaccionRow);
    const entidadCliente = await getEntidadByID(transaccionRow.idEntidadNumero);
    setSelectedTransaccionEntidad(entidadCliente);

    const {
      montoTotal,
      impuestos = [],
      montoDescuento = 0,
      porcentajeDescuento = 0,
    } = transaccionRow;
    const totalSinImpuestos = impuestos.reduce(
      (total, impuesto) => total - (impuesto.montoTotal || 0),
      montoTotal
    );
    const totalSinImpuestosYDescuento = totalSinImpuestos + montoDescuento;
    const totalFinal =
      totalSinImpuestosYDescuento * (1 - porcentajeDescuento / 100);

    setCalculatedTotal(totalFinal);
    setTotalMontoDescuento(montoDescuento);
    setPorcentajeDescuento(porcentajeDescuento);
    setMontoSinImpuesto(totalSinImpuestos);

    switch (transaccionRow.idDelTipoTransaccion) {
      case 1:
        setOpenModalVenta(true);
        break;
      case 2:
        setOpenModalCompra(true);
        break;
      case 3:
        setOpenModalPresupuesto(true);
        break;
      case 4:
        setOpenModalIngreso(true);
        break;
      case 5:
        setOpenModalEgreso(true);
        break;
      case 6:
        setOpenModalDevolucion(true);
        break;
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setOpenModalVenta(false);
    setOpenModalCompra(false);
    setOpenModalPresupuesto(false);
    setOpenModalIngreso(false);
    setOpenModalEgreso(false);
    setOpenModalDevolucion(false);
    setOpenModalVenta(false);
  };

  const handleFilter = async () => {
    try {
      const medioDePagoId = selectedMedioDePago ? selectedMedioDePago.id : null;
      const tipoMedioDePagoId = selectedTipoMedioDePago
        ? selectedTipoMedioDePago.id
        : null;
      const tipoTransaccionId = selectedTipoTransaccion
        ? selectedTipoTransaccion.id
        : null;
      const idEntidad = dniCliente
      ? dniCliente.id
      : null;
    fetchData(
      startDate,
      endDate,
      medioDePagoId,
      tipoMedioDePagoId,
      tipoTransaccionId,
      page,
      idTransaccionSearch,
      idEntidad
    );
    } catch (error) {}
  };

  const resetFilters = () => {
    setDniCliente(null);
    setSearchTextCliente("");
    setIdTransaccionSearch("");
    setSelectedTipoMedioDePago(null);
    setSelectedMedioDePago(null);
    setSelectedTipoTransaccion(null);

    // Mantener solo la fecha de inicio como hoy
    const today = dayjs();
    setStartDate(today.subtract(30, "day"));
    setEndDate(today);

    // Refrescar datos con filtros reseteados
    fetchData(startDate, endDate, null, null, null, null, null, null);
  };

  const handleTipoMedioDePagoChange = (tipo) => {
    setSelectedTipoMedioDePago(tipo);

    if (tipo.id === 7) {
      // Si el tipo es múltiple, deshabilitar el medio de pago individual
      setSelectedMedioDePago(null);
    }
  };

  const deleteDate1 = () => {
    setStartDate(null);
  };
  const deleteDate2 = () => {
    setEndDate(null);
  };

  useEffect(() => {
    getMedioDePagoIdTipoEspecifico(selectedTipoMedioDePago);
  }, [selectedTipoMedioDePago]);

  return (
    <div
      className="tablaVentasContainer"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh", // Toda la ventana
        overflowX: "auto", // Sin scroll en el contenedor principal
      }}
    >
      <ThemeProvider theme={theme}>
        <Paper
          className="filter-container"
          sx={{
            p: 1.5,
            mb: 2,
            display: "flex",
            alignItems: "center",
            flexWrap: "nowrap",
            gap: 1.5,
            backgroundColor: "#f9f9f9",
            borderRadius: 2,
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
            overflowX: "auto",
          }}
        >
          {/* Grupo de fechas */}
          <Box
            sx={{ display: "flex", alignItems: "center", minWidth: "320px" }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
                <DatePicker
                  label="Fecha desde"
                  value={startDate}
                  onChange={(newValue) => setStartDate(newValue)}
                  format="DD/MM/YYYY"
                  slotProps={{
                    textField: { size: "small", inputProps: { maxLength: 10 } },
                  }}
                  sx={{ width: "140px" }}
                />
                <IconButton
                  className="colorGeneralParaIconos"
                  onClick={deleteDate1}
                  color="primary"
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <DatePicker
                  label="Fecha hasta"
                  value={endDate}
                  onChange={(newValue) => setEndDate(newValue)}
                  format="DD/MM/YYYY"
                  slotProps={{
                    textField: { size: "small", inputProps: { maxLength: 10 } },
                  }}
                  sx={{ width: "140px" }}
                />
                <IconButton
                  className="colorGeneralParaIconos"
                  onClick={deleteDate2}
                  color="primary"
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            </LocalizationProvider>
          </Box>

          {/* Tipo de medio de pago */}
          <Box
            sx={{ display: "flex", alignItems: "center", minWidth: "180px" }}
          >
            <Autocomplete
              options={tipoMedioDePago}
              getOptionLabel={(option) => option.descripcion}
              value={selectedTipoMedioDePago || null}
              onChange={(event, newValue) =>
                setSelectedTipoMedioDePago(newValue)
              }
              size="small"
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Tipo de medio de pago"
                  size="small"
                />
              )}
            />
          </Box>

          {/* Medio de pago */}
          <Box
            sx={{ display: "flex", alignItems: "center", minWidth: "180px" }}
          >
            <Autocomplete
              options={medioDePagoIdTipoEspecifico}
              getOptionLabel={(option) => option.descripcion}
              value={selectedMedioDePago || null}
              onChange={(event, newValue) => setSelectedMedioDePago(newValue)}
              size="small"
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <TextField {...params} label="Medio de pago" size="small" />
              )}
              disabled={selectedTipoMedioDePago?.id === 7}
            />
          </Box>

          {/* Tipo de transacción */}
          <Box
            sx={{ display: "flex", alignItems: "center", minWidth: "180px" }}
          >
            <Autocomplete
              options={tipoTransaccion}
              getOptionLabel={(option) => option.descripcion}
              value={selectedTipoTransaccion || null}
              onChange={(event, newValue) =>
                setSelectedTipoTransaccion(newValue)
              }
              size="small"
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Tipo de transacción"
                  size="small"
                />
              )}
            />
          </Box>

          {/* Cliente */}
          <Box
            sx={{ display: "flex", alignItems: "center", minWidth: "220px" }}
          >
            <Autocomplete
              size="small"
              disablePortal
              options={entidadesClientesTresLetras.map((it) => ({
                label: `${it.descripcion} - ${it.apellido} - ${it.dniCuitCuil}`,
                ...it,
              }))}
              value={dniCliente}
              onChange={(event, newValue) => setDniCliente(newValue || null)}
              onInputChange={(event, newInputValue) =>
                setSearchTextCliente(newInputValue)
              }
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Cliente"
                  variant="outlined"
                  size="small"
                />
              )}
            />
          </Box>

          {/* Búsqueda por ID */}
          <TextField
            label="Buscar por ID"
            type="number"
            size="small"
            value={idTransaccionSearch}
            onChange={(e) => setIdTransaccionSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            sx={{ width: "140px" }}
          />

          {/* Botones de acción */}
          <Box
            sx={{ display: "flex", alignItems: "center", gap: 1, ml: "auto" }}
          >
            <Button
              variant="contained"
              onClick={handleFilter}
              startIcon={<SearchIcon />}
              size="small"
              sx={{
                backgroundColor: "#5b5b5f",
                textTransform: "none",
                padding: "6px 12px",
                color: "white",
                "&:hover": {
                  backgroundColor: alpha("rgb(244, 177, 14)", 0.8),
                },
              }}
            >
              Buscar
            </Button>
            <Tooltip title={filtersActive ? "Resetear filtros" : "Refrescar"}>
              <IconButton
                onClick={resetFilters}
                color="primary"
                size="small"
                sx={{
                  bgcolor: filtersActive
                    ? alpha(theme.palette.secondary?.main || "#f0f0f0", 0.1)
                    : "transparent",
                  "&:hover": {
                    bgcolor: alpha(
                      theme.palette.secondary?.main || "#f0f0f0",
                      0.2
                    ),
                  },
                }}
              >
                {filtersActive ? <FilterAltOffIcon /> : <ReplayIcon />}
              </IconButton>
            </Tooltip>
          </Box>
        </Paper>
        {/* Contenedor de la tabla */} {/* Tabla con Paper */}
        <Paper
          sx={{
            flex: 1,
            headerAlign: "center", // Ocupa el espacio restante
            m: 1,
            overflow: "hidden", // El DataGrid maneja su propio scroll
            borderRadius: 3,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            position: "relative",
          }}
        >
          <DataGrid
key={isNavbarCollapsed ? "collapsed" : "expanded"}
            rows={transaccionTransformedReforged}
            columns={columns}
            getRowId={(row) => row.id}
            pageSize={limit}
            paginationMode="server"
            className="tablaVentasDataGrid"
            rowCount={totalCount} // usa el total real de registros
            page={page - 1} // DataGrid cuenta desde 0
            onPageChange={(newPage) => setPage(newPage + 1)}
            onRowSelectionModelChange={(newSelection) => {
              const selectedData = transaccionTransformedReforged.filter(
                (row) => newSelection.includes(row.id)
              );
              setSelectedRows(selectedData);
            }}
            getRowHeight={() => 35}
            headerHeight={35}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "row-color-alt" // Alternar filas con este color
                : "row-color-default"
            }
            sx={{
              height: "100%",
              border: 0,
              "& .MuiDataGrid-footerContainer": {
                display: "none !important", // Si no funciona, usa la regla CSS global con !important
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#5b5b5f",
                color: "white",
                borderBottom: "2px solid #333",
                height: "45px !important",
                minHeight: "45px !important",
                maxHeight: "45px !important",
              },
              "& .MuiDataGrid-columnHeader": {
                //MANEJA CSS HEADER
                height: "45px !important",
                minHeight: "45px !important",
                maxHeight: "45px !important",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                //MANEJA CSS HEADER
                color: "white !important",
                lineHeight: "45px !important",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                color: "white !important",
              },
              "& .MuiDataGrid-columnHeaderTitle .MuiDataGrid-menuIconButton": {
                color: "white !important",
              },
              "& .MuiDataGrid-menuIconButton": {
                color: "rgb(244, 177, 14) !important",
              },
              "& .MuiInputBase-root": {
                color: "rgb(244, 177, 14) !important",
              },
              "& .MuiTablePagination-root": {
                color: "black !important",
              },
              "& .MuiSelect-icon": {
                color: "rgb(244, 177, 14) !important",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #ccc",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
              "& .MuiDataGrid-row": {
                "&:nth-of-type(even)": {
                  backgroundColor: "#F7F7F7",
                },
                "&:hover": {
                  backgroundColor: "#E3EAFD",
                  transition: "background 0.3s ease",
                },
              },
              "& .MuiDataGrid-footerContainer": {
                position: "sticky",
                bottom: 0,
                backgroundColor: "#ffffff",
                borderTop: "1px solid #ddd",
                zIndex: 10,
              },
              "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                width: "8px",
              },
              "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
                backgroundColor: "#888",
                borderRadius: "10px",
              },
            }}
            components={{
              Pagination: () => null,
            }}
          />
        </Paper>
        {/* Contenedor del footer (paginación) */}
        <Box sx={{ flexShrink: 0, p: 1 }}>
          <CustomPagination
            currentPage={page}
            totalPages={totalPages}
            totalCount={totalCount}
            vieneDe={"tablaTransaccion"}
            onPageChange={(newPage) => setPage(newPage)}
          />
        </Box>
        {/* Footer fijo */}
        <Paper
          sx={{
            width: "100%",
            borderTop: "1px solid #ddd",
            backgroundColor: "#f0f0f0",
          }}
        >
          <TableContainer
            component={Paper}
            sx={{ maxHeight: 300, width: "100%" }}
          >
            <Table sx={{ width: "100%" }}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>Referencias</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Venta</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Ingreso</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Venta + Ingreso</strong>
                  </TableCell>
                  <TableCell>
                    <strong> - </strong>
                  </TableCell>
                  <TableCell>
                    <strong>Compra</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Egreso</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Compra + Egreso</strong>
                  </TableCell>
                  <TableCell>
                    <strong> - </strong>
                  </TableCell>
                  <TableCell>
                    <strong>Total Final</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    align="center"
                    sx={{ color: "black", fontWeight: "bold" }}
                  >
                    Totales por fecha
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#4CAF50", fontWeight: "bold" }}
                  >
                    ${totalesPorTipoMedioDePago?.Venta.toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#4CAF50", fontWeight: "bold" }}
                  >
                    $
                    {totalesPorTipoMedioDePago?.Ingreso.toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#4CAF50", fontWeight: "bold" }}
                  >
                    $
                    {(
                      totalesPorTipoMedioDePago?.Venta +
                      totalesPorTipoMedioDePago?.Ingreso
                    ).toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "gray", fontWeight: "bold" }}
                  >
                    -
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#FF9800", fontWeight: "bold" }}
                  >
                    ${totalesPorTipoMedioDePago?.Compra.toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#FF9800", fontWeight: "bold" }}
                  >
                    ${totalesPorTipoMedioDePago?.Egreso.toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#FF9800", fontWeight: "bold" }}
                  >
                    $
                    {(
                      totalesPorTipoMedioDePago?.Compra +
                      totalesPorTipoMedioDePago?.Egreso
                    ).toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "gray", fontWeight: "bold" }}
                  >
                    -
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color:
                        totalesPorTipoMedioDePago?.Venta +
                          totalesPorTipoMedioDePago?.Ingreso -
                          totalesPorTipoMedioDePago?.Compra -
                          totalesPorTipoMedioDePago?.Egreso >=
                        0
                          ? "#4CAF50"
                          : "#FF9800",
                      fontWeight: "bold",
                    }}
                  >
                    $
                    {(
                      totalesPorTipoMedioDePago?.Venta +
                      totalesPorTipoMedioDePago?.Ingreso -
                      totalesPorTipoMedioDePago?.Compra -
                      totalesPorTipoMedioDePago?.Egreso
                    ).toLocaleString("es-AR")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell
                    align="center"
                    sx={{ color: "black", fontWeight: "bold" }}
                  >
                    Totales por medio de pago
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#4CAF50", fontWeight: "bold" }}
                  >
                    ${totalesPorTipo?.Venta.toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#4CAF50", fontWeight: "bold" }}
                  >
                    ${totalesPorTipo?.Ingreso.toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#4CAF50", fontWeight: "bold" }}
                  >
                    $
                    {(
                      totalesPorTipo?.Venta + totalesPorTipo?.Ingreso
                    ).toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "gray", fontWeight: "bold" }}
                  >
                    -
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#FF9800", fontWeight: "bold" }}
                  >
                    ${totalesPorTipo?.Compra.toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#FF9800", fontWeight: "bold" }}
                  >
                    ${totalesPorTipo?.Egreso.toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#FF9800", fontWeight: "bold" }}
                  >
                    $
                    {(
                      totalesPorTipo?.Compra + totalesPorTipo?.Egreso
                    ).toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "gray", fontWeight: "bold" }}
                  >
                    -
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color:
                        totalesPorTipo?.Venta +
                          totalesPorTipo?.Ingreso -
                          totalesPorTipo?.Compra -
                          totalesPorTipo?.Egreso >=
                        0
                          ? "#4CAF50"
                          : "#FF9800",
                      fontWeight: "bold",
                    }}
                  >
                    $
                    {(
                      totalesPorTipo?.Venta +
                      totalesPorTipo?.Ingreso -
                      totalesPorTipo?.Compra -
                      totalesPorTipo?.Egreso
                    ).toLocaleString("es-AR")}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </ThemeProvider>

      {/* Modal */}

      {openModalVenta === true ? (
        <ModalViewTablaVenta
          openModal={openModalVenta}
          handleCloseModal={handleCloseModal}
          selectedTransaccion={selectedTransaccion}
          selectedTransaccionEntidad={selectedTransaccionEntidad}
          transaccionItems={transaccionItems}
        />
      ) : null}
      {openModalCompra === true ? (
        <ModalViewTablaCompra
          openModal={openModalCompra}
          handleCloseModal={handleCloseModal}
          selectedTransaccion={selectedTransaccion}
          selectedTransaccionEntidad={selectedTransaccionEntidad}
          transaccionItems={transaccionItems}
        />
      ) : null}
      {openModalPresupuesto === true ? (
        <ModalViewTablaPresupuesto
          openModal={openModalPresupuesto}
          handleCloseModal={handleCloseModal}
          selectedTransaccion={selectedTransaccion}
          selectedTransaccionEntidad={selectedTransaccionEntidad}
          transaccionItems={transaccionItems}
        />
      ) : null}
      {openModalIngreso === true ? (
        <ModalViewTablaIngreso
          openModal={openModalIngreso}
          handleCloseModal={handleCloseModal}
          selectedTransaccion={selectedTransaccion}
          selectedTransaccionEntidad={selectedTransaccionEntidad}
          transaccionItems={transaccionItems}
        />
      ) : null}
      {openModalEgreso === true ? (
        <ModalViewTablaEgreso
          openModal={openModalEgreso}
          handleCloseModal={handleCloseModal}
          selectedTransaccion={selectedTransaccion}
          selectedTransaccionEntidad={selectedTransaccionEntidad}
          transaccionItems={transaccionItems}
        />
      ) : null}
      {openModalDevolucion === true ? (
        <ModalViewTablaDevolucion
          openModal={openModalDevolucion}
          handleCloseModal={handleCloseModal}
          selectedTransaccion={selectedTransaccion}
          selectedTransaccionEntidad={selectedTransaccionEntidad}
          transaccionItems={transaccionItems}
        />
      ) : null}
    </div>
  );
}
